// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { PopupForm } from './popup-form';
import { render, createElement, emptyFn } from './common';

/**
 * @class Jsw.ProgressDialog
 * @extends Jsw.PopupForm
 */
export const ProgressDialog = Class.create(PopupForm, {
    _initConfiguration($super, config) {
        config = Object.extend({
            singleRowButtons: true,
            scrollable: true,
        }, config || {});
        $super(config);

        this.progressBarItem = this._getConfigParam('progressBarItem');
    },

    updateItem(progressBarItem) {
        const isComplete = this.progressBarItem.isComplete();
        this.progressBarItem = progressBarItem;
        if (!isComplete && this.progressBarItem.isComplete()) {
            this.toggleButtonsArea(true);
            if (this.progressBarItem.isCompleteSuccessfully()) {
                const onComplete = this._getConfigParam('onComplete', emptyFn);
                setTimeout(onComplete, 2000);
            }
        }
        this.renderProgress();
    },

    _getHeadingActions() {
        const ce = createElement;
        return ce('a.s-btn', { onclick: this.hide.bind(this) }, [
            ce('i.icon-background-tasks'),
            this.lmsg('minimize'),
        ]);
    },

    render($super) {
        $super();

        this.setBoxType('form-box');
        this.renderProgress();

        this.toggleButtonsArea(false);
        this.addRightButton(this.lmsg('close'), this.hide.bind(this));
    },

    renderProgress() {
        const ce = createElement;
        const steps = this.progressBarItem.getSteps();
        this.setTitle(this.progressBarItem.getProgressTitle());
        render($(this._contentAreaId), ce('.progress-steps', Object.keys(steps).map(function (stepName) {
            const step = steps[stepName];

            return ce('.progress-step', { class: this.getClassName(step) }, [
                step.icon && ce('.progress-step-icon', ce('i.icon-md', ce('img', { src: step.icon }))),
                ce('.progress-step-body', [
                    this.renderStatus(step),
                    ce('.progress-step-name', step.title.escapeHTML()),
                    this.renderContent(step),
                ]),
            ]);
        }.bind(this))), 'inner');
    },

    getClassName(step) {
        if (step.status === this.progressBarItem.STATUS_DONE && this.progressBarItem.hasErrors()) {
            return 'progress-step-warning';
        }
        if (step.status === this.progressBarItem.STATUS_DONE) {
            return 'progress-step-success';
        }
        if (step.status === this.progressBarItem.STATUS_ERROR) {
            return 'progress-step-danger';
        }
        return null;
    },

    renderStatus(step) {
        const ce = createElement;
        if (step.status === this.progressBarItem.STATUS_DONE) {
            return ce('.progress-step-status', [ce('i.icon-ok'), ' ', this.lmsg('statusDone')]);
        }
        if (step.status === this.progressBarItem.STATUS_ERROR) {
            return ce('.progress-step-status', [ce('i.icon-warning'), ' ', this.lmsg('statusError')]);
        }
        if (step.status === this.progressBarItem.STATUS_CANCELED) {
            return ce('.progress-step-status', [ce('i.icon-delete'), ' ', this.lmsg('statusCanceled')]);
        }
        if (step.status === this.progressBarItem.STATUS_NOT_STARTED) {
            return ce('.progress-step-status.text-muted', [ce('i.icon-waiting'), ' ', this.lmsg('statusNotStarted')]);
        }
        return '';
    },

    renderContent(step) {
        const ce = createElement;
        let content;
        if (step.status === this.progressBarItem.STATUS_ERROR) {
            content = this.progressBarItem.getErrorsString();
        } else if (this.progressBarItem.isStarted()) {
            content = this.renderProgressIndicator(step);
        }
        return content && ce('.progress-step-content', content);
    },

    renderProgressIndicator(step) {
        const ce = createElement;
        const progressIndicator = [];
        if (step.progressStatus) {
            progressIndicator.push(ce('.progress-label', step.progressStatus.escapeHTML()));
        }
        const value = parseInt(step.progress);
        if (-1 === value) {
            progressIndicator.push(
                ce('.progress', ce('.progress-bar.progress-bar-striped.active', { style: 'width: 100%;' }))
            );
        } else if (step.status === this.progressBarItem.STATUS_RUNNING) {
            progressIndicator.push(ce('.progress', ce('.progress-bar', { style: `width: ${value}%;` })));
            progressIndicator.push(ce('.progress-label', this.lmsg('percentCompleted', { percent: value })));
        }
        return progressIndicator;
    },
});



// WEBPACK FOOTER //
// ./jsw/progress-dialog.js